const validateIPWithFirewall = async (ip, envVariables) => {
  const url = `${envVariables.REACT_APP_ATLAS_AZFUNCTION}/firewallrules/${ip}${envVariables.REACT_APP_ATLAS_AZFKEY_FRWRULES}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const result = await response.json();

    return result;
  } catch (error) {
    console.error("An error occurred while validating the IP:", error);
    return null;
  }
};

export default validateIPWithFirewall;
